import { BaseRouter } from "./Router/BaseRouter";

export const App = () => {
  return (
    <BaseRouter />
  );
};
